const VALID_TONES = new Set(["positive", "watch", "concern", "critical"]);

function capitalizeFirstLetter(value) {
  return String(value || "").replace(/\p{L}/u, (letter) => letter.toLocaleUpperCase());
}

function bookmarkValue(bookmark) {
  if (typeof bookmark === "string") return { text: bookmark, tone: "watch" };
  if (!bookmark || typeof bookmark !== "object") return null;
  const text = String(bookmark.text || "").trim();
  if (!text) return null;
  const tone = VALID_TONES.has(bookmark.tone) ? bookmark.tone : "watch";
  return { text, tone };
}

export default function RelationshipBookmark({ bookmark, className = "" }) {
  const value = bookmarkValue(bookmark);
  if (!value) return null;
  const displayText = capitalizeFirstLetter(value.text);

  return (
    <span
      className={`relationship-bookmark relationship-bookmark--${value.tone}${className ? ` ${className}` : ""}`}
      title={displayText}
      aria-label={`Relationship bookmark: ${displayText}`}
    >
      <span className="relationship-bookmark__dot" aria-hidden="true" />
      <span className="relationship-bookmark__text">{displayText}</span>
    </span>
  );
}
